import { useQuery } from '@tanstack/react-query';

import { useMarketParam, useRequestIdParam } from '~/contexts/UrlParamsContext';
import { mapJiraRequest } from '~/controllers/mapping/requests';
import { getRequest } from '~/controllers/requests';
import { IJiraIssue } from '~/domain/IJiraIssue';
import { useJiraConfigQuery } from '~/hooks/useJiraConfigQuery';
import { useJiraProjectConfig } from '~/hooks/useJiraProjectConfig';

export const useRequestQuery = () => {
  const { data: jiraProjectConfig } = useJiraProjectConfig();
  
  const { data: config, isSuccess } = useJiraConfigQuery();
  const market = useMarketParam();
  const requestId = useRequestIdParam();

  return useQuery(['getRequest', { requestId, market, jiraProjectConfig }], getRequest, {
    enabled: !!requestId && isSuccess && !!jiraProjectConfig,
    cacheTime: Infinity,
    staleTime: Infinity,
    select: (request: IJiraIssue) => {
      return config ? mapJiraRequest(request, config) : undefined;
    },
  });
}

export const useRequest = () => useRequestQuery().data;
